class RecentArticles extends HTMLElement {

  constructor() {
    super();
    this.initSlider();
  }

  initSlider() {
    const articleSliderOptions = {
      container: this.querySelector('[data-slider]'),
      items: 2,
      controls: false,
      preventScrollOnTouch: 'auto',
      mouseDrag: true,
      responsive: {
        768: {
          items: 3,
          slideBy: 3,
        },
        992: {
          items: 4,
          slideBy: 4,
        },
      },
    };
    tns(articleSliderOptions);
  }
}
customElements.define('recent-articles', RecentArticles);